import get from 'lodash/get';
import { ArcadeListItem, ArcadesAppState } from 'routes/arcades/interfaces';

export const getArcadesList = (state: ArcadesAppState): Array<ArcadeListItem> => get(state, 'arcades.list', []);
